export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker-legacy.48f1cd97.worker.js");
}
